import { createContext, useContext } from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";
import { v4 as uuidv4 } from "uuid";

const PrivateChatA2AApiContext = createContext(null);

export function PrivateChatA2AApiProvider({ children }) {
  const { postStream, get } = useApiService(CONFIG.SERVER_ORGANIZATION);

  const sendMessage = async (chatKey, input, files, conversation, callback) => {
    const messageParts = [];

    if (input?.trim() !== "") {
      messageParts.push({
        kind: "text",
        text: input,
      });
    }

    const sendParams = {
      jsonrpc: "2.0",
      method: "message/stream",
      id: uuidv4(),
      params: {
        message: {
          messageId: uuidv4(),
          role: "user",
          kind: "message",
          contextId: uuidv4(),
          parts: messageParts,
        },
      },
    };

    try {
      const response = await postStream(
        `/v1/private_chats/int/${chatKey}/`,
        sendParams
      );

      const stream = response.data;

      const reader = stream
        .pipeThrough(new TextDecoderStream())
        .getReader();

      while (true) {
        const { value, done } = await reader.read();
        if (value) {
          const line = value.match(/^data:\s*(.*)$/m);
          if (line) {
            callback(line[1]);
          }
        }
        if (done) break;
      }

      return response.data;
    } catch (error) {
      console.error("Error sending message to private chat A2A:", error);
      throw error;
    }
  };

  return (
    <PrivateChatA2AApiContext.Provider value={{ sendMessage }}>
      {children}
    </PrivateChatA2AApiContext.Provider>
  );
}

export function usePrivateChatA2AApi() {
  const context = useContext(PrivateChatA2AApiContext);
  if (!context) {
    throw new Error(
      "usePrivateChatA2AApi must be used within a PrivateChatA2AApiProvider"
    );
  }
  return context;
}
